import { useCallback, useEffect, useState } from 'react'
import { IDropdownData, TypeOrNull } from 'models/Common'

export const amountLiftedFrequentlyDropdownData = [
  {
    value: 50,
    label: '50lbs',
  },
  {
    value: 45,
    label: '45lbs',
  },
  {
    value: 40,
    label: '40lbs',
  },
  {
    value: 35,
    label: '35lbs',
  },
  {
    value: 30,
    label: '30lbs',
  },
  {
    value: 25,
    label: '25lbs',
  },
  {
    value: 20,
    label: '20lbs',
  },
  {
    value: 15,
    label: '15lbs',
  },
  {
    value: 10,
    label: '10lbs',
  },
  {
    value: 5,
    label: '5lbs',
  },
]

export const amountLiftedOccasionallyDropdownData = [
  { value: 50, label: '50lbs' },
  {
    value: 45,
    label: '45lbs',
  },
  {
    value: 40,
    label: '40lbs',
  },
  {
    value: 35,
    label: '35lbs',
  },
  {
    value: 30,
    label: '30lbs',
  },
  {
    value: 25,
    label: '25lbs',
  },
  {
    value: 20,
    label: '20lbs',
  },
  {
    value: 15,
    label: '15lbs',
  },
  {
    value: 10,
    label: '10lbs',
  },
  { value: 5, label: '5lbs' },
]

export const amountOfTimeSpentOnFeetDropdownData = [
  {
    value: 100,
    label: '100%',
  },
  {
    value: 75,
    label: '75%',
  },
  {
    value: 50,
    label: '50%',
  },
  {
    value: 25,
    label: '25%',
  },
]

export const DEFAULT_AMOUNT_LIFTED_FREQUENTLY =
  amountLiftedFrequentlyDropdownData[9]
export const DEFAULT_AMOUNT_LIFTED_OCCASIONALLY =
  amountLiftedOccasionallyDropdownData[7]
export const DEFAULT_AMOUNT_OF_TIME_SPENT_ON_FEET =
  amountOfTimeSpentOnFeetDropdownData[0]

/**
 * Return the desired dropdown options array depending on the passed fieldName
 * @param fieldName
 * @returns
 */
const getOptionsFromFieldName = (fieldName: string) => {
  if (fieldName === 'amount_lifted_frequently')
    return amountLiftedFrequentlyDropdownData
  if (fieldName === 'amount_lifted_occasionally')
    return amountLiftedOccasionallyDropdownData
  if (fieldName === 'amount_of_time_spent_on_feet')
    return amountOfTimeSpentOnFeetDropdownData

  // eslint-disable-next-line no-console
  console.warn(
    'Please specify a correct fieldName in the usePhysicalRequirementsDropdown hook.',
  )
  return []
}

/**
 * Return a DropdownOption depending on the fieldName and the fieldValue
 * @param fieldName
 * @param fieldValue
 * @returns
 */
export const mapFieldFromValue = (fieldName: string, fieldValue: number) => {
  const dropdownData = getOptionsFromFieldName(fieldName)
  const selectedOption = dropdownData.find(
    dropdownItem => fieldValue === dropdownItem.value,
  )
  return selectedOption as IDropdownData
}

/**
 * Hook that exposes utils for the Physical Requirements related dropdowns
 * @param setFieldValue
 * @param initialValue
 * @param fieldName
 * @returns
 */
export const usePhysicalRequirementsDropdown = (
  setFieldValue: (field: string, value: any) => void,
  initialValue: TypeOrNull<number | string>,
  fieldName: string,
): [
  TypeOrNull<IDropdownData>,
  (field: string, selected: IDropdownData) => void,
] => {
  const [selectedOption, setSelectedOption] = useState<
    TypeOrNull<IDropdownData>
  >(
    initialValue !== null
      ? mapFieldFromValue(fieldName, Number(initialValue))
      : null,
  )

  const handleDropdownChange = useCallback(
    (field: string, selected: IDropdownData) => {
      setFieldValue(field, selected.value)
      setSelectedOption(selected)
    },
    [setFieldValue],
  )

  useEffect(() => {
    setFieldValue(
      fieldName,
      initialValue !== null ? Number(initialValue) : null,
    )
  }, [initialValue, setFieldValue, fieldName])

  return [selectedOption, handleDropdownChange]
}
